<template>
  <header class="bg-white border-b border-neutral-200 lg:hidden sticky top-0 z-30 shadow-sm">
    <div class="px-4 h-16 flex items-center justify-between">
      <!-- Mobile Menu Button -->
      <button
        @click="$emit('toggle-mobile-menu')"
        class="p-2 hover:bg-neutral-100 rounded transition-colors text-neutral-600 hover:text-neutral-900"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <!-- Page Title / Logo -->
      <div class="flex items-center space-x-2">
        <div class="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
          <span class="text-white font-bold text-sm">CC</span>
        </div>
        <span class="font-semibold text-neutral-900">{{ pageTitle }}</span>
      </div>

      <!-- Spacer for balance -->
      <div class="w-10"></div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

defineEmits(['toggle-mobile-menu'])

const route = useRoute()

// Get page title from route meta or path
const pageTitle = computed(() => {
  const pathMap: Record<string, string> = {
    '/': 'Calmren',
    '/contact': 'Contact',
    '/dashboard': 'Dashboard',
    '/time-log': 'Time Log',
    '/clients': 'Clients',
    '/invoices': 'Invoices',
    '/expense-entry': 'Expenses',
    '/expense-sheet': 'Expense Sheet',
    '/tax-calculator': 'Tax Calculator',
    '/business-calculations': 'Business Settings',
    '/fsu-projects': 'FSU Projects',
  }

  return pathMap[route.path] || 'Calmren'
})
</script>
